import apiClient from "../../utils/api.client";
import { getSaaId } from "../../utils/session.utils";

export const getOnLine = async (
  organizationId,
  desde,
  hasta,
  agencia,
  subagencia,
) => {
  try {
    const saaId = getSaaId();
    const response = await apiClient.get(
      `/saaServices/saaServices/services/abaco/detalleMovimientosOnline?organizacionId=${saaId}&fechadesde=${desde}&fechahasta=${hasta}&agencia=${agencia}&subagencia=${subagencia}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getOnLine EP: ", error);
    throw error;
  }
};

// Movimientos de billetera (Depósitos y Retiros) - Lotline
export const getWalletOnLine = async (
  {
    agencia,
    fechaDesde,
    fechaHasta,
    codigoOrganizacion,
    subagencia,
  }
) => {
  try {
    const { data } = await apiClient.get(
      `/billetera-service/api-user/billetera/outside/depositospedidosretiroabaco`,
      {
        params: {
          agencia,
          fechaDesde,
          fechaHasta,
          codigoOrganizacion,
          subagencia,
        },
      }
    );
    return data;
  } catch (error) {
    console.error("Error at getWalletOnLine EP: ", error);
    throw error;
  }
};
